module.exports =
  '_PAID_INTRO':
    'PAGE_TITLE': 'GOLF NETWORK PLUS'
    'TITLE': 'Use the new and improved features to analyze your golfing abilities!'
    'SUB_TITLE': 'To utilized the improved features, you must be registered with a paid-membership'
    'FEE': 'When you register as a paid-member (￥500/mo.) you can see more detailed course and score analyses'
    'SETTING': 'Configure your target value'
    'SETTING_CONTENT': 'Enter your personal score data to set your goals, see your progress, and improve your game'
    'COMPATION': 'Compare your scores, course by course'
    'COMPATION_CONTENT': 'Set your individual round results and scoring average'
    'PC': 'Edit your scores directly from your PC'
    'PC_CONTENT': 'Enter your scores through app and edit them from your PC at a later time'
    'ENSURE': 'To utilize these great features, you must be registered with a paid-membership'
    'REGISTER': 'Register for your paid-membership'
    'BTN_TITLE': 'Become a paid member'
    'BTN_NOTE': 'Pay ￥500/mo. (sales taxes not included)'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/paid-introduction/i18n/en.coffee